'use client';

import React from 'react'

import OurCultureHeroSection from './components/OurCultureHeroSection'
import OurWorkCultureSection from './components/OurWorkCultureSection'
import LifeBenzatineInfotech from '../components/LifeBenzatineInfotech'
import JoinBenzatine from './components/JoinBenzatine'
import EmployeeGrowth from './components/EmployeeGrowth'
import YourNextCareer from './components/YourNextCareer'
import { ContactUsForm } from '@/components'

function OurCulturePage() {
   return (
      <>
         <OurCultureHeroSection />
         <OurWorkCultureSection />
         <LifeBenzatineInfotech />
         <JoinBenzatine />
         <EmployeeGrowth />
         <YourNextCareer />
         <ContactUsForm />
      </>
   )
}

export default OurCulturePage
